module.exports = __webpack_public_path__ + "static/media/ReferralsImage.81308433.png";